'use client'

import { useSearchParams } from 'next/navigation'
import { landingpage_freeuse } from '@/constants/trace'
import { handleUETClick } from '@/lib/utils'
import { ImmediateUseButton } from './immediate-use-button'

export function Kol() {
  const searchParams = useSearchParams()
  const queryString = searchParams.toString()
  const loginPath = queryString ? `https://app.aitubiao.com/sign-in?${queryString}` : 'https://app.aitubiao.com/sign-in'

  return (
    <section className="py-20 md:py-24">
      <div className="flex justify-center" onClickCapture={handleUETClick}>
        <ImmediateUseButton href={loginPath} traceEvent={{ event: landingpage_freeuse }} icon={<ActionIcon className="h-10 w-10" />} />
      </div>
    </section>
  )
}

const ActionIcon = ({ className }: { className?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0551 9.64268C20.5046 8.02337 22.7874 7.98684 23.2885 9.59092L23.5912 10.5597C24.6889 14.0745 27.2599 16.9385 30.6361 18.4083C31.9152 18.9653 31.892 20.7888 30.6058 21.3292C27.015 22.8377 24.2877 25.9072 23.2289 29.6554L22.4818 32.3019C22.2148 33.2473 20.8819 33.2684 20.5844 32.3321L19.6537 29.4024C18.5087 25.7997 15.8245 22.8734 12.3392 21.4093C11.0181 20.8543 11.0254 18.9719 12.3568 18.4425C16.0781 16.9633 18.8931 13.8275 19.9642 9.96885L20.0551 9.64268ZM30.3373 26.6124C30.4565 26.2062 31.0325 26.2063 31.1517 26.6124L31.2621 26.9903C31.5265 27.8935 32.2434 28.5933 33.1527 28.836C33.4501 28.9155 33.4936 29.3198 33.2201 29.461L32.9672 29.5909C32.1464 30.0146 31.5217 30.74 31.224 31.6144L31.0394 32.1554C30.9447 32.4337 30.5511 32.4317 30.4594 32.1524L30.2445 31.5001C29.9614 30.6378 29.3359 29.9293 28.515 29.5421L28.3099 29.4454C28.0322 29.3141 28.0687 28.9076 28.3656 28.8282C29.2567 28.5903 29.9589 27.9047 30.2181 27.0196L30.3373 26.6124ZM9.88709 5.1085C10.0189 4.63989 10.6829 4.63999 10.8148 5.1085L11.1947 6.45811C11.723 8.33715 13.2335 9.77883 15.1351 10.2189C15.4569 10.2933 15.4869 10.7395 15.1781 10.8565L14.9564 10.9405C12.8256 11.7478 11.2732 13.6127 10.8656 15.8546L10.7416 16.5353C10.6489 17.0433 9.93058 17.0703 9.80018 16.5704L9.46424 15.2843C8.95223 13.3214 7.54604 11.714 5.66834 10.9464L5.47987 10.8692C5.17478 10.7445 5.21051 10.3019 5.53163 10.2276C7.45531 9.78247 8.98349 8.32377 9.51795 6.42295L9.88709 5.1085Z"
        fill="white"
      />
    </svg>
  )
}
